export default __webpack_public_path__ + "static/media/uh-oh-img.4f398e83.png";